export const formatHeading = category => {
	switch(category) {
		case 'popular':
			return 'Popular reports'
		case 'newest':
			return 'Recently published'
		case 'featured':
			return 'Featured reports'
		case 'stories':
			return 'Submitted Posts'
		case 'likes':
			return 'Liked Posts'
		case 'saves':
			return 'Bookmarked Posts'
		default:
			return category
	}
}

export const formatFeed = type => {
	switch(type) {
		case 'submitted':
			return 'Submitted Posts'
		case 'upvotes':
			return 'Liked Posts'
		case 'bookmarked':
			return 'Bookmarked Posts'
		default:
			return type
	}
}

export const formatAPI = type => {
	switch(type) {
		case 'submitted':
			return 'stories'
		case 'upvotes':
			return 'likes'
		case 'bookmarked':
			return 'saves'
		default:
			return 'stories'
	}
}

export const formatDate = created => {
	let formattedDate = new Date(created)
	let year = formattedDate.getFullYear()
	let month = formattedDate.getMonth()+1
	let date = formattedDate.getDate()
	switch(month) {
		case 1:
			month = 'Jan'
			break
		case 2:
			month = 'Feb'
			break
		case 3:
			month = 'Mar'
			break
		case 4:
			month = 'Apr'
			break
		case 5:
			month = 'May'
			break
		case 6:
			month = 'Jun'
			break
		case 7:
			month = 'Jul'
			break
		case 8:
			month = 'Aug'
			break
		case 9:
			month = 'Sep'
			break
		case 10:
			month = 'Oct'
			break
		case 11:
			month = 'Nov'
			break
		case 12:
			month = 'Dec'
			break
	}
	var yeartoText = year.toString()
	var yearShort = yeartoText.slice(-2)
	var lastDigit = +(yearShort)
	return month + " " + date + " '" + lastDigit
}


// WEBPACK FOOTER //
// ./src/utility/Formatter.js